import { OverlayProvider } from '@revdotcom/vaporwave';

import { ReCaptchaProvider } from './pages/ReCaptchaContext';

/**
 * State provider for all Identity UI context. Should be added by branded packages
 * to the top of the react tree
 * @param {object} props parameters
 * @param {Element} props.children inner elements
 * @returns {Element} JSX
 */
export const IdentityProvider = (props: {
    children: JSX.Element | JSX.Element[];
}) => {
    return (
        <OverlayProvider>
            <ReCaptchaProvider>{props.children}</ReCaptchaProvider>
        </OverlayProvider>
    );
};
